export default {
    data() {
        return {}
    },

    methods: {
        async getSiteContent() {
            let siteContent = await this.axios.get(`${process.env.VUE_APP_ROOT_API}/api/siteContent/`);
            return siteContent.data[0];
        },

        patchSiteContent(siteContent) {

            return this.axios.patch(`${process.env.VUE_APP_ROOT_API}/api/siteContent/${siteContent._id}`,
                siteContent,
                {headers: {Authorization: localStorage.getItem('Authorization')}
                });

        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/api/siteContentAPI.js